// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"526c95be","31":"8e9262a9","60":"254cf947","118":"131e9f80","165":"4e9819de","344":"1e11c67b","453":"30dc6a82","608":"64b768a1","630":"716ad867","665":"04e9c8ee","700":"54ee03e2","747":"81e4c8dc","807":"1b7bdb83","923":"a223a1c6","975":"1b212633","981":"86686284"}[chunkId] + ".chunk.js";
};